import React, { useContext } from "react";
import { GlobalContext } from "GlobalContext";
import {
  HeroWrapper,
  TitleContainer,
  ImageContainer,
} from "components/Header/styles/HeroStyles";
import {
  Bone,
  LogoBone,
  NavItemBone,
  HeroTitleBones,
  HeroImageBone,
  Section,
  Grid,
  CardImageBone,
  VisuallyHidden,
} from "./styles/SkeletonStyles";

// Shown while a page's GraphQL query is in flight (GlobalContext.isLoading):
// the outline of the page about to appear, instead of a blank band. The hero
// reuses the real hero's containers so nothing moves when it is replaced.

export const HeroSkeleton = () => (
  <HeroWrapper className="hero" aria-hidden="true">
    <TitleContainer>
      <HeroTitleBones>
        <Bone dark w="300px" h="34px" />
        <Bone dark w="240px" h="34px" />
        <Bone dark w="380px" h="64px" mt="18px" />
      </HeroTitleBones>
    </TitleContainer>
    <ImageContainer>
      <HeroImageBone />
    </ImageContainer>
  </HeroWrapper>
);

export const PageSkeleton = () => {
  const { currentLang } = useContext(GlobalContext);

  return (
    <div className="main-container" role="status" aria-busy="true">
      <VisuallyHidden>
        {currentLang === "en" ? "Loading…" : "Chargement…"}
      </VisuallyHidden>
      <Section className="fixed-container" aria-hidden="true">
        <Bone w="260px" h="40px" mb="50px" />
        <Grid>
          {[0, 1].map((i) => (
            <div key={i}>
              <CardImageBone />
              <Bone w="40%" h="14px" mt="24px" />
              <Bone w="90%" h="22px" mt="14px" />
              <Bone w="70%" h="22px" mt="10px" />
            </div>
          ))}
        </Grid>
      </Section>
    </div>
  );
};

// The navbar's logo and labels come from their own query.
export const LogoSkeleton = () => <LogoBone dark aria-hidden="true" />;

const MENU_WIDTHS = ["150px", "100px", "112px", "76px", "104px", "96px"];

export const MenuSkeleton = () =>
  MENU_WIDTHS.map((w) => (
    <NavItemBone dark key={w} w={w} h="14px" aria-hidden="true" />
  ));
